import Vue from "vue";
import Vuex from "vuex";

import global from "@/store/global";
import detector from "@/store/detector";
import trainer from "@/store/trainer";
import history from "@/store/history";
import imageSelection from "@/store/imageSelection";
import notification from "@/store/notification";
import profile from "@/store/profile"
import model from "@/store/model";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "hachix-local-data",
      paths: [
        "global.lang",
        "global.auth.username",
        "global.auth.guest",
        "global.auth.idToken",
        "global.auth.accessToken",
        "global.showDetector",
        "global.showTrainer",
        "global.auth.userInfo",
      ],
    }),
  ],
  modules: {
    global,
    detector,
    trainer, 
    history,
    notification,
    profile,
    imageSelection,
    model
  }
})